export default "__VITE_ASSET__qV65_zHz__"